import type { CSSProperties, FC, ReactNode } from 'react'

import Image from 'next/image'
import { isOptimizable } from '@/lib/images'

interface SmartImageProps {
    src: string
    alt: string
    sizes: string
    className?: string
    style?: CSSProperties
    preload?: boolean
}

/**
 * Fills its positioned parent. Images on the site's own CDN are resized automatically;
 * any other address (pasted into the CMS) is shown as-is so the page never breaks.
 */
export const SmartImage: FC<SmartImageProps> = ({ src, alt, sizes, className, style, preload = false }): ReactNode => {
    return (
        <Image
            src={src}
            alt={alt}
            fill
            sizes={sizes}
            preload={preload}
            unoptimized={!isOptimizable(src)}
            className={className}
            style={style}
        />
    )
}
